import React, { useState, useEffect } from 'react';
import { Scale, Minus, Plus, Check, Loader2 } from 'lucide-react';

/** Widget compact "Données corporelles" : poids du jour avec steppers ±, sur la page principale. */
export const WeightQuickWidget = ({ latestWeight, loggedToday, onLog, en, onOpenFull }) => {
  const [draft, setDraft] = useState(latestWeight || 70);
  const [dirty, setDirty] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (!dirty) setDraft(latestWeight || 70); }, [latestWeight, dirty]);

  const bump = (delta) => { setDraft((v) => Math.max(30, +((v || 70) + delta).toFixed(1))); setDirty(true); };

  const save = async () => {
    setBusy(true);
    try { await onLog(draft); setDirty(false); }
    finally { setBusy(false); }
  };

  return (
    <div className="rounded-3xl bg-white/[0.035] backdrop-blur-xl border border-white/10 shadow-[0_0_30px_-12px_rgba(217,70,239,0.25)] p-5" data-testid="weight-widget">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Scale className="w-5 h-5 text-primary" />
          <h3 className="font-bold text-white">{en ? 'Body data' : 'Données corporelles'}</h3>
        </div>
        <button onClick={onOpenFull} className="text-xs font-semibold text-zinc-400 hover:text-primary transition-colors" data-testid="weight-open-full-btn">
          {en ? 'History' : 'Historique'}
        </button>
      </div>
      <div className="flex items-center justify-between gap-3">
        <button onClick={() => bump(-0.1)} className="w-11 h-11 rounded-full bg-white/5 hover:bg-white/10 flex items-center justify-center text-white transition-colors" data-testid="weight-decrease-btn">
          <Minus className="w-4 h-4" />
        </button>
        <div className="text-center">
          <p className="text-2xl font-black text-white tabular-nums" data-testid="weight-widget-value">{(draft || 0).toFixed(1)} <span className="text-sm font-semibold text-zinc-500">kg</span></p>
          {!loggedToday && <p className="text-[11px] text-zinc-500">{en ? 'Not logged today' : 'Pas encore saisi aujourd\'hui'}</p>}
        </div>
        <button onClick={() => bump(0.1)} className="w-11 h-11 rounded-full bg-white/5 hover:bg-white/10 flex items-center justify-center text-white transition-colors" data-testid="weight-increase-btn">
          <Plus className="w-4 h-4" />
        </button>
      </div>
      {dirty && (
        <button onClick={save} disabled={busy} className="mt-4 w-full py-2.5 rounded-xl font-bold text-white bg-gradient-to-r from-primary to-pink-500 hover:scale-[1.01] transition-transform disabled:opacity-60 flex items-center justify-center gap-2" data-testid="weight-save-quick-btn">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />} {en ? 'Log today\'s weight' : "Enregistrer le poids du jour"}
        </button>
      )}
    </div>
  );
};

export default WeightQuickWidget;
